import { lazy } from "react";

export const MANUALS = {
  liquidations: {
    title: "Módulo de Liquidaciones",
    component: lazy(() => import("./LiquidationsManual")),
  },
  legalFiles: {
    title: "Módulo de Expedientes",
    component: lazy(() => import("./LegalFilesManual")),
  },
  lawsuits: {
    title: "Títulos Electrónicos",
    component: lazy(() => import("./LawsuitsManual")),
  },
  paymentOrders: {
    title: "Órdenes de Pago",
    component: lazy(() => import("./PaymentOrdersManual")),
  },
  lawyers: {
    title: "Módulo de Abogados",
    component: lazy(() => import("./LawyersManual")),
  },
  users: {
    title: "Módulo de Usuarios",
    component: lazy(() => import("./UsersManual")),
  },
  security: {
    title: "Seguridad — Roles",
    component: lazy(() => import("./SecurityManual")),
  },
  settings: {
    title: "Configuración",
    component: lazy(() => import("./SettingsManual")),
  },
  jobHistory: {
    title: "Historial de Procesos",
    component: lazy(() => import("./JobHistoryManual")),
  },
  workspace: {
    title: "Módulo de Área de Trabajo",
    component: lazy(() => import("./WorkspaceManual")),
  },
};
